import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { ComplianceTermsListActionsProps } from './props';
import { useComplianceTermsListActions } from './hook';

export const ComplianceTermsListActions = ({
    id,
}: ComplianceTermsListActionsProps) => {
    const { handleEdit } = useComplianceTermsListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
